import { gql } from "@edreamsodigeo/frontend-api-client";

import { LOGIN_RESPONSE_FRAGMENT } from "../../fragments";

export const PASSWORD_LOGIN_MUTATION = gql`
  ${LOGIN_RESPONSE_FRAGMENT}
  mutation PasswordLogin($request: PasswordLoginRequest!) {
    passwordLogin(request: $request) {
      ...LoginResponseParts
    }
  }
`;

export default PASSWORD_LOGIN_MUTATION;
